import { render, staticRenderFns } from "./FirstTimePass.vue?vue&type=template&id=48bb411c&scoped=true&"
import script from "./FirstTimePass.vue?vue&type=script&lang=js&"
export * from "./FirstTimePass.vue?vue&type=script&lang=js&"
import style0 from "./FirstTimePass.vue?vue&type=style&index=0&id=48bb411c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb411c",
  null
  
)

export default component.exports